import { render, staticRenderFns } from "./PSIntegration.vue?vue&type=template&id=ecc9c706&"
import script from "./PSIntegration.vue?vue&type=script&lang=js&"
export * from "./PSIntegration.vue?vue&type=script&lang=js&"
import style0 from "./PSIntegration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports